export const ADD_ORDER = "ADD_ORDER",
  GET_ORDERS = "GET_ORDERS",
  CLEAR_ORDERS = "CLEAR_ORDERS",
  GET_WEEKLY_ORDER_STATUS = "GET_WEEKLY_ORDER_STATUS";
